import React from 'react'
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer-section bg-dark text-white pt-4 pb-2" style={{ marginTop: "auto" }}>
      <div className="container-fluid px-0">
        <div className="row mx-0 align-items-center justify-content-center">
          <div className="col-12 col-md-8 text-center mb-2 mb-md-0">
            <div className="align-items-center justify-content-center gap-2" style={{ fontSize: "1rem" }}>
              <span className="d-block" style={{ fontSize: "0.95rem", color: "#cbd5e1" }}>
                <Link to="/privacy-policy" style={{ color: '#60a5fa', textDecoration: 'none', fontWeight: 600 }}>Privacy Policy</Link> • <Link to="/refund-policy" style={{ color: '#60a5fa', textDecoration: 'none', fontWeight: 600 }}>Refund Policy</Link> • <Link to="/terms-of-service" style={{ color: '#60a5fa', textDecoration: 'none', fontWeight: 600 }}>Terms of Service</Link>
              </span>
              <br />
              <span className="d-block mb-2 mb-md-0" style={{ fontWeight: 500 }}>
                <i className="fa fa-copyright mr-2"></i>Copyright &copy; {new Date().getFullYear()} <a href="https://mduschooled.in" target="_blank" rel="noopener noreferrer" style={{ color: "#60a5fa", textDecoration: "none", fontWeight: 600 }}>mduschooled.in</a> || Powered by <a href="https://idntica.com" target="_blank" rel="noopener noreferrer" style={{ color: "#60a5fa", textDecoration: "none", fontWeight: 600 }}>Idntica</a> || Version 1.0.1 || All rights reserved.
              </span>


            </div>
          </div>
        </div>
      </div>
      <style>{`
        .footer-section {
          font-family: 'Inter', Arial, sans-serif;
          font-size: 1rem;
          border-top: 1px solid #374151;
        }
        @media (max-width: 767.98px) {
          .footer-section {
            font-size: 0.95rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
          }
        }
      `}</style>
    </footer>
  )
}
